export const API_URL = "https://api-app.eventegration.com/graphql/";
export const IMAGES_API_URL = "https://api-app.eventegration.com/public/";
export const UPLOAD_IMAGES_API_URL =
  "https://api-app.eventegration.com/graphql";
// export const UPLOAD_IMAGES_API_URL = "http://localhost:4013";
// export const IMAGES_API_URL = "http://localhost:4013/public/";
// export const API_URL = "http://localhost:4013/graphql";
// export const API_URL = "https://api-reg-eventegration-com.vercel.app/graphql";
// export const IMAGES_API_URL = "http://localhost:4000/";

export const formatTime = (timeString) => {
  const [hours, minutes] = timeString.split(":");
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};
